<template>
  <div>
    <swiper>
      <swiper-item v-for="(item, index) in banners" :key="index" >
        <!--<img :src="~images/goods1.png" alt="">-->
        <img class="banner" :src="item" alt />
      </swiper-item>
    </swiper>
    <span v-if="false"
      class="row flex-center font24 f-FFFFFF halftimg position_a"
      style="right: .426667rem; bottom: .32rem;"
    >1/{{banners.length}}</span>
  </div>
</template>

<script>
// @ is an alias to /src
import { Swiper, SwiperItem } from "@/components/common/swiper";

export default {
  name: "DetailSwiper",
  data() {
    return {
      currentIndex:1
    };
  },
  props: {
    banners: {
      type: Array,
      default: []
    }
  },
  components: {
    Swiper,
    SwiperItem
  },
  methods: {
    
  }
};
</script>
<style  scoped>
.banner {
  height: 10.506667rem;
  width: 100%;
}
</style>
